import Devices from '../../components/Devices';

export default function DevicesPage() {
  return <div className="account-page-content"><div className="page-heading"><p className="eyebrow">Account access</p><h1>Trusted devices</h1><p>Review Meridian app installations registered to your account and revoke anything you don't recognize.</p></div><Devices /></div>;
}
